<ng-container
  *ngIf="!string_filter && baseDatasource.isTableLoaded && baseDatasource.totalItem$.getValue() === 0; else elseBlock">
  <app-card-empty icon="{{iconNone}}" text="Belum terdapat data product."></app-card-empty>
</ng-container>

<ng-template #elseBlock>
  <app-card [header]="true">
    <ng-container cardHeader>

      <app-input-search
        (actionFilter)="onSearch($event)"
        [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
        placeholder="Cari Nama Produk / Jenis Pestisida"
        value="{{string_filter}}"
      ></app-input-search>

      <div class="ms-auto position-relative">
        <app-filter-table
          (actionClick)="onClickFilter()"
          (actionReset)="handleResetFilter()"
          [isActiveFilter]="isActiveFilter"
          [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
          [isOpenFilter]="isOpenFilter"
        >
          <div class="menu menu-sub menu-sub-dropdown w-300px w-md-350px show filter-body" id="kt-toolbar-filter">
            <!--begin::Header-->
            <div class="px-7 py-5">
              <div class="fs-4 text-dark fw-bold">Filter</div>
            </div>
            <div class="separator border-gray-200"></div>

            <form (ngSubmit)="handleSubmitFilter()" [formGroup]="filterForm" [ngClass]="'w-100'" class="form">
              <div class="px-7 py-5">
                <div class="mb-10">
                  <label class="form-label fs-5 mb-6">Jenis Pestisida:</label>
                  <app-input-select
                    [class]="'w-100'"
                    [options]="pestisidaList"
                    formControlName="pesticide_type"
                    ngDefaultControl
                    placeholder="Pilih salah satu"></app-input-select>
                </div>

                <div class="d-flex justify-content-end">
                  <button #btnReset (click)="handleResetFilter()" class="btn btn-light btn-active-light-primary me-4"
                          type="reset">Reset
                  </button>
                  <button [disabled]="filterService.validateSubmitFilter(filterForm)" class="btn btn-primary" type="submit">Terapkan</button>
                </div>
              </div>
            </form>
          </div>
        </app-filter-table>
      </div>
    </ng-container>

    <ng-container cardBody>
      <ng-container
        *ngIf="(isActiveFilter || string_filter) && baseDatasource.isTableLoaded && baseDatasource.totalItem$.getValue() === 0; else elseFilterBlock">
        <app-card-empty icon="{{iconNone}}" text="Belum terdapat data product."></app-card-empty>
      </ng-container>
      <ng-template #elseFilterBlock>
        <div class="table-responsive">
          <table
            [dataSource]="baseDatasource"
            class="table w-100 gy-5 table-row-bordered align-middle"
            mat-table
            matSort
          >
            <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
              <ng-container *ngIf="tableColumn.isSortable; else notSortable">
                <th
                  *matHeaderCellDef
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div>
                    {{tableColumn.title}}
                  </div>
                </th>
              </ng-container>
              <ng-template #notSortable>
                <th
                  *matHeaderCellDef
                  [class.min-w-100px]="tableColumn.key !== 'action' && tableColumn.key !== 'id'"
                  mat-header-cell
                >
                  <div *ngIf="baseDatasource.isFinishLoadingSubject.value">
                    {{tableColumn.title}}
                  </div>
                  <div *ngIf="!baseDatasource.isFinishLoadingSubject.value">
                    <app-table-content [width]="70"></app-table-content>
                  </div>
                </th>
              </ng-template>
              <td *matCellDef="let element" class="px-3" mat-cell>
                <ng-container [ngSwitch]="tableColumn.key">
                  <div *ngSwitchCase="'actions'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject" [type]="'icon'">
                     <span
                       (click)="handleAction(element['id'])"
                       [inlineSVG]="STRING_CONSTANTS.ICON.IC_EDIT"
                       class="svg-icon svg-icon-2 cursor-pointer"
                     ></span>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'plant_type_name'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                      <div *ngFor="let plantType of element[tableColumn.key]" class="d-flex flex-column">
                        <div class="row">
                          {{plantType}}
                        </div>
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'status'">
                    <app-table-content [height]="30" [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
                                       [width]="120">
                    <span
                      class="badge badge__status {{ element['status'] === 'PENDING' ? 'badge__status--pending' : 'badge__status--inactive' }}"
                    >{{ element[tableColumn.key] }}</span>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'unit_price'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                      <div>
                        {{toRupiah(element[tableColumn.key])}}
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchDefault>
                    <app-table-content [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject">
                      <span>{{ element[tableColumn.key] }} </span>
                    </app-table-content>
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          </table>

          <div class="d-flex justify-content-between py-4">
            <app-mai-material-bottom-table
              (changePage)="changePageEvent($event)"
              [baseDataTableComponent]="baseDatasource"
              [isFinishLoadingSubject]="baseDatasource.isFinishLoadingSubject"
              class="w-100"
            ></app-mai-material-bottom-table>
          </div>
        </div>
      </ng-template>
    </ng-container>

  </app-card>
</ng-template>
